import { RecordValues } from '@wyz/types';
import { CONTAINER_TYPES } from '~/common/schemas';
import { IThemeColors } from '@wyz/types';
import {
  TranslationKeys,
  IContainerOrderStatus,
  ITransportItemStatus,
} from '~/common/types';

export const CONTAINER_TYPE_LABEL: Record<
  RecordValues<typeof CONTAINER_TYPES>,
  keyof TranslationKeys
> = {
  [CONTAINER_TYPES.TRUCK]:
    'app.container.pricing_policy.form.container_types.truck',
  [CONTAINER_TYPES.CONTAINER]:
    'app.container.pricing_policy.form.container_types.container',
};

export const CONTAINER_ORDER_STATUS_LABEL_LOOKUP: Record<
  IContainerOrderStatus,
  keyof TranslationKeys
> = {
  SENT_TO_SUPPLIER: 'app.purchase.order_status.send_supplier',
  IN_DELIVERY: 'app.container_orders.status.in_delivery',
  DELIVERED: 'app.container_orders.status.delivered',
  ACCEPTED_BY_SUPPLIER: 'app.purchase.order_status.accepted',
  REJECTED_BY_SUPPLIER: 'app.purchase.order_status.canceled_supplier',
};

export const TRANSPORT_ITEM_STATUS_LABEL_LOOKUP: Record<
  ITransportItemStatus,
  keyof TranslationKeys
> = {
  SENT_TO_SUPPLIER: 'app.purchase.order_status.send_supplier',
  IN_DELIVERY: 'app.container_orders.status.in_delivery',
  DELIVERED: 'app.container_orders.status.delivered',
  ACCEPTED_BY_SUPPLIER: 'app.purchase.order_status.accepted',
  REJECTED_BY_SUPPLIER: 'app.purchase.order_status.canceled_supplier',
};

export const CONTAINER_TYPE_LABEL_LOOKUP: Record<
  string,
  keyof TranslationKeys
> = {
  CONTAINER: 'app.container.pricing_policy.form.container_types.container',
  TRUCK: 'app.container.pricing_policy.form.container_types.truck',
};

export const CONTAINER_ORDER_STATUS_COLOR_LOOKUP: Record<string, IThemeColors> =
  {
    SENT_TO_SUPPLIER: 'warning',
    IN_DELIVERY: 'warning',
    DELIVERED: 'success',
    ACCEPTED_BY_SUPPLIER: 'success',
    REJECTED_BY_SUPPLIER: 'danger',
  };

export const TRANSPORT_ITEM_STATUS_COLOR_LOOKUP: Record<string, IThemeColors> =
  {
    SENT_TO_SUPPLIER: 'warning',
    IN_DELIVERY: 'warning',
    DELIVERED: 'success',
    ACCEPTED_BY_SUPPLIER: 'success',
    REJECTED_BY_SUPPLIER: 'danger',
  };
